function HeroSection() {
  const { SectionEyebrow } = window.AppComponents;
  const { benefits } = window.AppData.siteContent;

  return (
    <header className="overflow-hidden rounded-[32px] border border-white/80 bg-white/80 px-5 py-5 shadow-glow backdrop-blur-xl md:px-7 md:pb-14">
      <nav className="grid gap-4 md:grid-cols-[auto_1fr_auto] md:items-center md:gap-[18px]">
        <div className="flex items-center gap-3">
          <div className="grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br from-peach to-orange-300 font-display text-sm font-bold tracking-[0.2em] text-white">
            CG
          </div>
          <div>
            <p className="m-0 text-base font-extrabold">CoverGrid</p>
            <p className="m-0 text-sm text-slate-500">Insurance made easy</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 text-sm font-semibold text-slate-700 md:justify-center md:gap-7">
          <a href="#products">Products</a>
          <a href="#plans">Top Plans</a>
          <a href="#reviews">Reviews</a>
          <a href="#faq">FAQ</a>
          <a href="/agent-dashboard">Dashboard</a>
        </div>

        <div className="flex flex-wrap gap-3">
          <a
            href="/buy-now"
            className="rounded-full bg-ink px-5 py-3 font-semibold text-white shadow-[0_14px_28px_rgba(20,48,74,0.2)] transition hover:-translate-y-0.5"
          >
            Buy Now
          </a>
          <button className="rounded-full border border-slate-200 bg-white/75 px-5 py-3 font-semibold text-ink transition hover:-translate-y-0.5">
            Renew Policy
          </button>
        </div>
      </nav>

      <section className="mt-10 grid items-center gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-11">
        <div>
          <SectionEyebrow>Compare. Choose. Feel covered.</SectionEyebrow>
          <h1 className="mt-5 max-w-[12ch] font-display text-5xl font-bold leading-[0.95] tracking-[-0.06em] text-ink sm:text-6xl lg:text-[5.4rem]">
            Find insurance that fits your life, not just your budget.
          </h1>
          <p className="mt-4 max-w-2xl text-lg leading-8 text-slate-500">
            A modern insurance marketplace inspired by trusted comparison platforms,
            built for quick discovery, clear pricing, and real human support.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <button className="rounded-full bg-gradient-to-br from-peach to-coral px-6 py-3.5 font-semibold text-white shadow-[0_14px_28px_rgba(225,95,56,0.26)] transition hover:-translate-y-0.5">
              View Free Quotes
            </button>
            <a
              href="/buy-now"
              className="rounded-full bg-ink px-6 py-3.5 font-semibold text-white shadow-[0_14px_28px_rgba(20,48,74,0.2)] transition hover:-translate-y-0.5"
            >
              Buy Now
            </a>
            <button className="rounded-full border border-slate-200 bg-white/75 px-6 py-3.5 font-semibold text-ink transition hover:-translate-y-0.5">
              Talk to an Advisor
            </button>
          </div>

          <ul className="mt-8 grid gap-3">
            {benefits.map((item) => (
              <li key={item} className="flex items-center gap-3 font-semibold">
                <span className="h-2.5 w-2.5 rounded-full bg-gradient-to-br from-mint to-emerald-500"></span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative grid gap-4">
          <div className="overflow-hidden rounded-[30px] border border-white/10 bg-white/10 backdrop-blur-sm">
            <img
              src="https://images.unsplash.com/photo-1763631019224-07719a29f76e?auto=format&fit=crop&w=1400&q=80"
              alt="Family walking together outdoors"
              className="h-[260px] w-full object-cover"
            />
          </div>

          <div className="rounded-[28px] bg-gradient-to-br from-slate-900 to-sky-950 p-7 text-white shadow-glow">
            <div className="inline-flex rounded-full bg-white/15 px-3 py-2 text-xs font-extrabold uppercase tracking-[0.16em]">
              Instant Recommendation
            </div>
            <h2 className="mt-4 font-display text-3xl font-bold">Health + Life Bundle</h2>
            <p className="mt-3 text-3xl font-extrabold">Rs 1,249/month</p>
            <p className="mt-2 text-sm text-white/70">
              Recommended for salaried couples aged 28-40
            </p>
            <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-4">
              <span className="text-sm text-white/70">Coverage match</span>
              <strong className="text-lg">92%</strong>
            </div>
          </div>

          <div className="grid gap-4 rounded-[28px] border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl sm:grid-cols-[auto_1fr] sm:items-center">
            <div className="grid h-[78px] w-[78px] place-items-center rounded-full bg-[conic-gradient(#63c7ab_0_78%,rgba(99,199,171,0.18)_78%_100%)] font-display text-2xl font-bold text-ink">
              4.8
            </div>
            <div>
              <p className="m-0 text-sm font-semibold text-slate-500">Trusted coverage score</p>
              <p className="mt-2 text-sm leading-6 text-slate-500">
                Based on renewals, support quality, and claim satisfaction.
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-gradient-to-br from-amber-50 to-white p-4 shadow-[0_22px_40px_rgba(52,70,85,0.16)] lg:absolute lg:-bottom-2 lg:-right-3">
            <strong className="block text-xl">2,40,000+</strong>
            <span className="text-sm text-slate-500">quotes generated this month</span>
          </div>
        </div>
      </section>
    </header>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.HeroSection = HeroSection;
